import { z } from 'zod';
/** Task, job, support and bug share one model with a `type` field. */
export const WorkItemType = z.enum(['task', 'job', 'support', 'bug']);
export const Priority = z.enum(['p1', 'p2', 'p3', 'p4']);
/** A status category drives behaviour (progress bars, "open" counts); the label is editable. */
export const StatusCategory = z.enum(['backlog', 'todo', 'active', 'review', 'blocked', 'waiting', 'done']);
export const DEFAULT_STATUSES = [
    { key: 'backlog', label: 'Backlog', category: 'backlog', color: 'slate' },
    { key: 'todo', label: 'To do', category: 'todo', color: 'slate' },
    { key: 'in_progress', label: 'In progress', category: 'active', color: 'blue' },
    { key: 'review', label: 'Review', category: 'review', color: 'violet' },
    // After Review, for work that ships to a test and then a live site (docs/adr/0089). Open until Done.
    { key: 'uat', label: 'UAT', category: 'review', color: 'orange', types: ['task', 'job', 'bug'] },
    { key: 'production', label: 'Production', category: 'review', color: 'green', types: ['task', 'job', 'bug'] },
    { key: 'blocked', label: 'Blocked', category: 'blocked', color: 'red' },
    { key: 'waiting_on_client', label: 'Waiting on client', category: 'waiting', color: 'orange', types: ['support'] },
    { key: 'resolved', label: 'Resolved', category: 'done', color: 'green', types: ['support'] },
    { key: 'done', label: 'Done', category: 'done', color: 'green' },
];
//# sourceMappingURL=work-items.js.map